import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardText
} from "reactstrap"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import LeadService from "services/Admin/LeadService"
import SalesRepsService from "services/Admin/SalesRepsService"
import SelectOptions from "components/SelectOptions"

function ModalForm({ modal, toggle, salesRep,lead_id,idsSelected, setShouldGetData ,type,setShouldUpdateDate }) {
    const leadService = new LeadService()
    const [loading, setLoading] = useState(false)
    const [salesRepOptions, setSalesRepOptions] = useState([])
    const [formData, setFormData] = useState({
        sales_rep_id: null,

    })
    useEffect(() => {
        if(salesRep?.value){
            setFormData({ sales_rep_id: salesRep })
        }else{
            setFormData({ sales_rep_id: null })

        }
    }, [])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleValidSubmit = (_, values) => {
        if (!formData.sales_rep_id) {
            toast.error("Please Select Sales Rep")
            return
        } else {
            setLoading(true)
            if(!!lead_id){
                const data = {
                    sales_rep_id: formData.sales_rep_id.value,
                    lead_id : lead_id ,
                }
                leadService.assignSalesRep(data).then(res=>{
                    if(res&& res.status===SuccessOk){
                        toast.success("Sales Rep Assigned successffuly")
                        if (type === "details") {
                            setShouldUpdateDate(c =>c+1)
                        }else{
                            setShouldGetData(true)
                        }
                        toggle()
                    }else{
                        setLoading(false)
                    }
                })
            } else {
                const data = {
                    sales_rep_id: formData.sales_rep_id.value,
                    lead_ids : idsSelected ,
                }
                leadService.updateMultiLead(data).then(res=>{
                    if(res&& res.status===SuccessOk){
                        toast.success("Sales Rep Assigned successffuly")
                        if (type === "details") {
                            setShouldUpdateDate(c =>c+1)
                        }else{
                            setShouldGetData(true)
                        }
                        toggle()
                    }else{
                        setLoading(false)
                    }
                })
            }
        }
    }
    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>

                <ModalBody>
                    <Row>
                        <Row className="my-0 p-1 d-flex justify-content-between">
                            <Col><span className="font-size-15 fw-bold">Assign Sales Rep </span></Col>
                        </Row>
                    </Row>
                    <hr />
                    <Row>
                        <Col md={12}>
                            <SelectOptions
                                label='Sales Rep'
                                placeholder='Select'
                                options={salesRepOptions}
                                handleSelectChange={(data) => {
                                    setFormData({ ...formData, sales_rep_id: data });
                                }}
                                selectedOption={formData.sales_rep_id}
                                Service={SalesRepsService}
                                setOptions={(options) => {
                                    setSalesRepOptions(options)
                                }}
                            />
                        </Col>
                    </Row>


                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-between">
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-secondary'>
                        Cancel
                        </button>
                    <button
                        type='submit'
                        disabled={loading ? true : false}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </AvForm>
        </Modal>

    )
}

export default ModalForm
